import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import SET_SELLER from './types';
export default {
  setSeller(_ref, payload) {
    return _asyncToGenerator(function* () {
      var {
        commit
      } = _ref;
      commit(SET_SELLER, payload);
    })();
  }

};